<template>
  <div class="d-flex flex-column position-relative align-self-stretch pie-wrap">

    <svg class="pie-vector" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient :id="uuid + 'inactiveGrad'" x1="100%" x2="-29.811%" y1="-56.973%" y2="213.826%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>

        <radialGradient :id="uuid + 'activeGrad'" cx="0" cy="72.941%" r="50.714%" fx="1.704%" fy="62.941%"
                        gradientTransform="scale(2.25) rotate(90 0.5 0.5)">
          <stop offset="0%" :stop-color="accent" stop-opacity="0"/>
          <stop offset="60.941%" :stop-color="accent" stop-opacity=".616"/>
          <stop offset="100%" :stop-color="accent"/>
        </radialGradient>
      </defs>

      <g fill="none" transform="translate(25 -25)">
        <circle
          class="inactive-pie"
          cx="100"
          cy="100"
          r="100"
          transform="rotate(-90 100 100) scale(0.45) translate(65 70)"
          stroke-width="100%"
          stroke-opacity="0.9"
          stroke-dasharray="630"
          :stroke-dashoffset="630 - (this[inactiveInd + 'Num'] / 100) * 630"
          :stroke="'url(#' + uuid + 'inactiveGrad)'"
        />

        <circle
          class="active-pie"
          cx="100"
          cy="100"
          r="100"
          transform="rotate(-90 100 100) scale(0.5) translate(50 50)"
          stroke-width="100%"
          stroke-opacity="0.9"
          stroke-dasharray="630"
          :stroke-dashoffset="630 - (this[industry + 'Num'] / 100) * 630"
          :stroke="'url(#' + uuid + 'activeGrad)'"
        />
      </g>

    </svg>

    <percentage
      :num="num"
      :hide-label="true"
      class="position-absolute pie-num"
      :font-size="36"
      :ind-override="indOverride"
    />

    <p class="text-center adobe-clean-black d-flex justify-content-center align-items-center w-100 pie-label"
       v-html="label.title"></p>
  </div>
</template>

<script>
  import { TweenMax, Power1 } from 'gsap'
  import { dataTransTime } from '@/lib/consts'
  import { gradPtColor } from '@/lib/funcs'
  import GraphFragMixin from '@/components/report/mixins/GraphFragMixin'

  export default {
    name: 'PieFillFragment',
    mixins: [ GraphFragMixin ],
    props: {
      itTarget: Number,
      mktgTarget: Number,
      stroke: { type: Array, default () { return [ this.accent, this.mainColor ] } }
    },
    data () {
      return { itNum: 0, mktgNum: 0 }
    },
    computed: {
      gradMidPt () {
        return gradPtColor( ...this.stroke, 0.5 )
      },
      inactiveInd () {
        return this.industry === 'mktg' ? 'it' : 'mktg'
      }
    },
    methods: {
      handleChange () {
        TweenMax.to( this, dataTransTime, {
          itNum: this.itTarget,
          mktgNum: this.mktgTarget,
          num: this.target,
          ease: Power1.easeInOut
        } )
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .pie-vector {
    width : 100%;
  }

  .pie-wrap {
    flex  : 1 0 0;
    width : calc(50% - #{rem(10)});
  }

  .pie-num {
    top  : 10%;
    left : 10%;
  }

  .pie-label {
    font-size      : rem(16);
    letter-spacing : 0.11125em;
    line-height    : 1;
    flex           : 1 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/PieFillFragment.vue